import { render, staticRenderFns } from "./RipaFavoritesGrid.vue?vue&type=template&id=73367ad9"
import script from "./RipaFavoritesGrid.vue?vue&type=script&lang=js"
export * from "./RipaFavoritesGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaFavoritesGrid.vue?vue&type=style&index=0&id=73367ad9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports